import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user clicks on the Dashboard Overview tutorial on the Help page
 * Event: dental_portal:help:dashboard_tutorial_clicked
 */
export function fireHelpDashboardTutorialClicked(): void {
  PosthogService.getInstance().track('dental_portal:help:dashboard_tutorial_clicked');
}
